import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CreateOperatorInvite } from '../../record-labels/action-creators';
import { CREATE_OPERATOR_INVITE } from '../../record-labels/actions';
import AppState from '../../state';
import { GetRecordLabelInvitesSuccess } from '../action-creators';
import SimpleUser from '../../../../../../common/types/user/simple-user';

export const addNewOperatorInvites = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateOperatorInvite>(CREATE_OPERATOR_INVITE),
    withLatestFrom(state$),
    map(([action, state]) => {
      return new GetRecordLabelInvitesSuccess('operator', [
        {
          id: action.invite.address,
          created_at: new Date(),
          updated_at: new Date(),
          inviterId: action.invite.inviter.id!,
          is_existing_user: !!action.invite.userId,
          email_or_phone: action.invite.address,
          contact_type: 'email',
          name: action.invite.name,
          status: 'pending',
          type: 'operator',
          metadata: {
            inviter: action.invite.inviter as SimpleUser,
          },
        },
        ...state.invites.recordLabel.operator,
      ]);
    })
  );
